import axiosInstance from "../../../../shared/api/axiosInstance.js";
import { baseUrl, DELETE_MAIN_CATEGORY_FEILD, DELETE_CATEGORY_FEILD, EDIT_MAIN_CATEGORY_FEILD, EDIT_CATEGORY_FEILD, CREATE_MAIN_CATEGORY_FEILD, CREATE_CATEGORY_FEILD } from "../../../../shared/api/endpoints.js";
import { configReq } from "../../../../shared/lib/functions.js";
/** Keeps the existing DELETE request and response contract. */
export function deleteRequest(searchParams, data, token) {
  return axiosInstance.delete(`${baseUrl}/${searchParams.get("isParent") === "true" ? DELETE_MAIN_CATEGORY_FEILD : DELETE_CATEGORY_FEILD}?id=${data.id}`, configReq(token));
}

/** Keeps the existing PUT request and response contract. */
export function putRequest(searchParams, datas, token) {
  return axiosInstance.put(`${baseUrl}/${searchParams.get("isParent") === "true" ? EDIT_MAIN_CATEGORY_FEILD : EDIT_CATEGORY_FEILD}`, {
    ...datas
  }, configReq(token, true));
}

/** Keeps the existing POST request and response contract. */
export function postRequest(searchParams, datas, token) {
  return axiosInstance.post(`${baseUrl}/${searchParams.get("isParent") === "true" ? CREATE_MAIN_CATEGORY_FEILD : CREATE_CATEGORY_FEILD}`, {
    ...datas
  }, configReq(token));
}
